import marketingController from './marketing.controller';

export default angular
  .module('st.Marketing', [])
  .controller('marketingController', marketingController);
